// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","sideNavigation":"_3YgfaEUNLf_oAN_1KNq1R0","sideNavigationOpen":"kpRQKF7XLB_gXk5s58nj5","navigationItems":"_1mENPyU2rSzyo8OqXJV9UU"};